import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import SmartBuildingList from './components/SmartBuildingList'


const { Cell } = ResponsiveGrid;

const SmartBuilding = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="智慧建築列表"
        breadcrumbs={[
          {
            name: '智慧建築專區',
          },
          {
            name: '智慧建築列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <SmartBuildingList />
    </Cell>
  </ResponsiveGrid>
);

export default SmartBuilding;
